import { KeycloakErrorHandlerConfig } from '@shared/services/keycloak-error-handler/keycloak-error-handler.config';

export class KeycloakErrorHandler {
  public static handle(error: unknown, context: string): void {
    (window as any)?.dtrum?.reportError(`${ KeycloakErrorHandlerConfig.errorInit.context } ${ context } ${error}`);
  }
}
